import React, { FC } from 'react'
import StorefrontCategoryTree, { StorefrontCategoryTreeItem } from '@local-types/categoryTrees/storefrontCategoryTree'
import { ActiveFilters } from 'reducers/filtersReducer'
import StorefrontFilters from '@local-types/filters/storefrontFilters'
import { HR } from 'components/base/typography/misc'
import { FilterChip } from 'components/base/buttons/filterChip'
import { ProductFilterChipsStyles } from '../filteredProductsList.styles'
interface Props {
	mainTreeFilter: {
		item: StorefrontCategoryTree | null | undefined
		isRoot: boolean
	}
	activeFilters: ActiveFilters
	filters: StorefrontFilters | null
	handleMainTreeItemClick: (treeItem: StorefrontCategoryTreeItem, activeChildren?: StorefrontCategoryTreeItem[]) => void
	handleFilterTreeItemClick: (treeItem: StorefrontCategoryTreeItem) => void
}

const ProductFilterChips: FC<Props> = ({ mainTreeFilter, activeFilters, filters, handleMainTreeItemClick }) => {
	const activeChildren = mainTreeFilter.item?.children?.filter(c => activeFilters.catTreePath.includes(c.categoryId))
	return (
		<ProductFilterChipsStyles>
			{mainTreeFilter.item && (
				<>
					<HR mt="1.5rem" mb="1.5rem" />
					{mainTreeFilter.item.children?.map(child => (
						<FilterChip
							onClick={handleMainTreeItemClick.bind(
								null,
								child,
								child.children.length <= 0 ? activeChildren : undefined,
								mainTreeFilter.item ? mainTreeFilter.item.children : undefined
							)}
							key={child.id}
							active={activeFilters.catTreePath.includes(child.id)}>
							{child.name}
						</FilterChip>
					))}
					{mainTreeFilter.item.children?.length !== 0 && <HR mt="1.5rem" mb="1.5rem" />}
				</>
			)}
		</ProductFilterChipsStyles>
	)
}

export default ProductFilterChips
